import React from "react";
import GlassSealsFeature from "./GlassSealsFeature";
import { Visibility } from "semantic-ui-react";

const GlassSeals = props => (
  <div>
    <Visibility {...props} once={false}>
      <GlassSealsFeature />
    </Visibility>
  </div>
);

export default GlassSeals;



// WEBPACK FOOTER //
// ./src/pages/GlassSeals/GlassSeals.js